module.exports = __webpack_public_path__ + "static/img/detect05.52454ff.png";


//////////////////
// WEBPACK FOOTER
// ./src/module/technology/images/detect05.png
// module id = 579
// module chunks = 4